import React, { Fragment } from 'react';
import { isProfileAdviser } from '@finect/front-core/Profiles';
import { EntityCard } from '../../EntityCard';
export var AuthorInline = function AuthorInline(_ref) {
  var author = _ref.author,
    _ref$isUser = _ref.isUser,
    isUser = _ref$isUser === void 0 ? false : _ref$isUser,
    _ref$withEntityCard = _ref.withEntityCard,
    withEntityCard = _ref$withEntityCard === void 0 ? false : _ref$withEntityCard,
    _ref$loggedIn = _ref.loggedIn,
    loggedIn = _ref$loggedIn === void 0 ? false : _ref$loggedIn;
  var id = author.id,
    type = author.type,
    name = author.name,
    alias = author.alias,
    displayName = author.displayName,
    image = author.image,
    _author$organizations = author.organizations,
    organizations = _author$organizations === void 0 ? [] : _author$organizations;
  var isAdviser = isProfileAdviser(author);
  var company = organizations ? organizations.length > 0 ? organizations[0] : null : null;
  var isPro = type === 'company' || isAdviser;
  var cardProps = {
    type: 'profile',
    entity: {
      id: id,
      name: name,
      subtype: type === 'company' ? 'company' : 'user',
      alias: alias,
      displayName: displayName,
      icon: image,
      company: company,
      adviser: isAdviser,
      verified: isPro,
      aditionalIcon: null
    },
    loggedIn: loggedIn
  };
  var component = React.createElement("span", null, displayName);
  return React.createElement(Fragment, null, !isUser && withEntityCard ? React.createElement(EntityCard, cardProps, component) : component);
};